// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge_1e-5Nplkv9oAbOR7iMJmns"};